import * as React from 'react';
export const useCollapse = ({ isOpen: isOpenDefault, collapsible = true, }) => {
    const [isOpen, setIsOpen] = React.useState(isOpenDefault && collapsible);
    const toggleCollapse = () => {
        if (collapsible) {
            setIsOpen(!isOpen);
        }
    };
    return { isOpen, toggleCollapse };
};
//# sourceMappingURL=useCollapse.js.map